// i18n translations for Jarix Dashboard
export type Language = 'es' | 'en'

export interface Translations {
  // Header
  securityOverview: string
  updatedNow: string
  updatedAgo: string
  exportPDF: string
  refresh: string
  refreshing: string

  // Time ranges
  last24h: string
  last7d: string
  last30d: string

  // Sidebar sections
  principal: string
  dashboard: string
  threats: string
  users: string
  devices: string
  security: string
  vulnerabilities: string
  mfaAccess: string
  compliance: string
  reports: string
  export: string
  history: string
  // Sprint 4 — tenant billing portal
  account: string
  billing: string
  branding: string
  billingTitle: string
  billingSubtitle: string
  billingLoading: string
  billingEmpty: string
  billingLegalName: string
  billingTaxId: string
  billingCountry: string
  billingPaymentTerms: string
  billingSummaryPeriods: string
  billingSummaryOutstanding: string
  billingSummaryPaid: string
  billingSummaryLastInvoice: string
  billingHistoryTitle: string
  billingPeriodSingular: string
  billingPeriodPlural: string
  billingColPeriod: string
  billingColUsers: string
  billingColPricePerUser: string
  billingColTotal: string
  billingColStatus: string
  billingColInvoice: string
  billingColDue: string
  billingPaidOn: string
  billingDownloadPdf: string
  billingStatusPending: string
  billingStatusSentFi: string
  billingStatusInvoiced: string
  billingStatusPaid: string
  billingStatusOverdue: string
  billingStatusVoid: string

  // SaaS metrics (admin view — RevenueAnalytics)
  saasMrr: string
  saasArr: string
  saasArpu: string
  saasGrowthMom: string
  saasNrr: string
  saasLtv: string
  saasMonthlyChurn: string
  saasForecastTitle: string
  saasForecastSubtitle: string
  saasInsufficientData: string

  // Score Card
  securityHealthScore: string
  basedOn: string
  goal: string
  goalGradeB: string
  pointsPossible: string
  of100: string
  protectionEndpoints: string
  userSecurity: string
  vulnerabilitiesLabel: string
  connectivity: string

  // Priority Actions
  priorityActions: string
  resolveToImprove: string
  activeDetectionsUnresolved: string
  criticalCVEsUnpatched: string
  usersWithoutMFA: string
  userWithoutMFA: string
  suspendedAccountsWithAccess: string
  suspendedAccountWithAccess: string
  unauthorizedAppsDetected: string
  unauthorizedAppDetected: string
  activeDetectionUnresolved: string
  criticalCVEUnpatched: string
  criticalLabel: string
  highLabel: string
  mediumLabel: string
  lowLabel: string

  // Metric Cards
  threatsBlocked: string
  last7Days: string
  activeDetections: string
  requireReview: string
  avgMTTR: string
  responseTime: string
  devicesLabel: string
  withCrowdStrike: string
  protectedDevices: string
  usersLabel: string
  fromJumpCloud: string
  mfaAdoptionLabel: string
  totalVulnerabilities: string
  fromSpotlight: string

  // Threats Table
  usersWithActiveThreats: string
  correlationJumpCloudCrowdStrike: string
  user: string
  device: string
  detection: string
  severity: string
  action: string
  noActiveThreatsAllBlocked: string
  investigate: string
  tactic: string

  // Vulnerabilities
  vulnerabilitiesSpotlight: string
  critical: string
  high: string
  medium: string
  low: string
  cvesExploitedActively: string
  affectsDevices: string
  patchAvailable: string
  noPatch: string
  viewDetails: string
  deviceAffected: string
  devicesAffected: string

  // MFA Status
  mfaStatus: string
  goalMFA: string
  usersWithMFA: string
  totpAuthenticator: string
  pushNotifications: string
  withoutMFAActive: string
  adoption: string

  // Anomalies
  unusualGeoAccess: string
  loginFromCountry: string
  usualLocation: string
  impossibleTravel: string
  countriesInHour: string
  blockUser: string
  revokeSessions: string

  // Shadow IT / SaaS Management
  unauthorizedApps: string
  shadowITDetectedBy: string
  application: string
  devicesCount: string
  risk: string
  block: string
  remoteAccess: string
  p2pFileSharing: string
  saasApplications: string
  jumpCloudSaaSManagement: string
  newlyDiscovered: string
  approved: string
  unapproved: string
  ignored: string
  noSaaSAppsDetected: string
  saaSAppsWillAppear: string
  discovered: string
  moreApps: string
  status: string

  // Compliance
  policyCompliance: string
  jumpCloudPolicies: string
  diskEncryption: string
  screenLock: string
  firewall: string
  osUpdated: string
  notCompliant: string

  // ZTA
  zeroTrustAssessment: string
  crowdstrikeZTA: string
  sensorHealth: string
  osSecurity: string
  patchStatus: string
  browserPlugins: string
  aboveThreshold: string
  belowThreshold: string
  threshold: string

  // Benchmarks
  yourPostureVsIndustry: string
  mfaAdoption: string
  patchCompliance: string
  mttd: string
  endpointCoverage: string
  you: string
  industry: string
  better: string
  needsImprovement: string

  // ROI
  valueGeneratedByJarix: string
  estimationBasedOnMetrics: string
  estimatedSavings: string
  basedOnMTTR: string
  avoidedIncidents: string
  blockedThreatsLabel: string
  protectedAssets: string
  devicesAndUsers: string
  lossesAvoided: string
  lossesAvoidedDesc: string
  timeSaved: string
  timeSavedDesc: string
  complianceGapsClosed: string
  complianceGapsClosedDesc: string

  // Timeline
  securityScoreEvolution: string
  historicalTrend: string
  lastMonths: string
  eventNewUsers: string
  eventEndpointsInstalled: string
  eventMFAEnabled: string
  lastDaysWithEvents: string
  ransomwareBlocked: string
  cvesPatched: string
  noSecurityEventsRecorded: string
  scoreHistoryWillAppear: string

  // Modals
  close: string
  cveDetails: string
  criticalVulnerabilities: string
  cveExploitedWarning: string
  cveId: string
  description: string
  affectedDevices: string
  patch: string
  available: string
  pending: string
  recommended: string
  applyPatch: string
  viewInSpotlight: string
  viewInCrowdStrike: string
  activeProtection: string

  // CVE Modal
  cvesActive: string
  cvesExploitedInWild: string
  detectedVulnerabilities: string
  applyPatchesImmediately: string
  implementMitigation: string
  monitorAffectedDevices: string

  // Vuln Drill-Down Modal
  vulnDrillTitle: string
  vulnDrillSubtitle: string
  vulnDrillAffectedDevices: string
  vulnDrillNoCVEs: string
  vulnDrillLoading: string
  vulnDrillViewInCS: string
  vulnDrillShowMore: string
  vulnDrillCVEs: string

  // Blocked Threats Modal
  blockedThreatsTitle: string
  blockedThreatsDescription: string
  blocked: string
  needAttention: string
  blockRate: string
  threatsByCategory: string
  malware: string
  malwareDesc: string
  ransomware: string
  ransomwareDesc: string
  phishing: string
  phishingDesc: string
  exploits: string
  exploitsDesc: string
  pups: string
  pupsDesc: string
  whatDoesThisMean: string
  realTimeProtection: string
  threatsNeutralized: string
  mlPreventedZeroDay: string
  viewAllThreats: string
  downloadReport: string

  // Action Modal
  impactedItems: string
  recommendations: string
  goToSection: string
  viewRelatedSection: string

  // Actions descriptions
  detectionsDescription: string
  cvesDescription: string
  mfaDescription: string
  suspendedDescription: string
  shadowItDescription: string

  // Cyber Risk Report
  cyberRiskTitle: string
  cyberRiskRiskScore: string
  cyberRiskGrade: string
  cyberRiskLastAssessment: string
  cyberRiskSecurityProfile: string
  cyberRiskSeverity: string
  cyberRiskDownloadReport: string
  cyberRiskViewInSocRadar: string
  cyberRiskNoData: string
  cyberRiskSyncPending: string
  cyberRiskCategory: string
  cyberRiskImpact: string

  // SocRadar PDF Report
  socradarReportTitle: string
  socradarReportScores: string
  socradarReportCVEs: string
  socradarReportDarkWeb: string
  socradarReportEmail: string
  socradarReportRansomware: string
  socradarReportInfra: string
  socradarReportNoData: string
  socradarReportSafe: string
  socradarReportDownload: string

  // Section Headers - Alerts, Users, Devices
  securityAlertsTitle: string
  jumpcloudUsersTitle: string
  devicesTitle: string
  alertsSource: string
  alertsDate: string
  alertsDescription: string
  alertsSeverity: string
  alertsStatus: string
  alertsNoAlerts: string
  alertsAll: string
  usersSummaryTotal: string
  usersSummaryActive: string
  usersSummarySuspended: string
  usersSummaryNoMFA: string
  usersName: string
  usersEmail: string
  usersStatus: string
  usersMFA: string
  usersLastLogin: string
  usersPasswordStatus: string
  usersActive: string
  usersSuspended: string
  usersYes: string
  usersNo: string
  usersNever: string
  usersExpired: string
  usersValid: string
  usersSearchPlaceholder: string
  usersMFAType: string
  usersMFATotp: string
  usersMFAWebauthn: string
  usersMFAPush: string
  usersMFASms: string
  usersMFANone: string
  usersFilterAll: string
  usersFilterNoMFA: string
  usersFilterPasswordExpiring: string
  usersFilterLocked: string
  usersFilterNewUsers: string
  usersFilterInactive: string
  usersFilterActive: string
  usersFilterSuspended: string
  usersFilterLabel: string
  usersExportCSV: string
  usersNoResults: string
  usersShowingCount: string
  usersRisk: string
  usersFilterHighRisk: string
  userRiskLow: string
  userRiskMedium: string
  userRiskHigh: string
  userDrawerRiskTitle: string
  userDrawerNoRiskFactors: string
  userDrawerIdentity: string
  userDrawerUsername: string
  userDrawerUserId: string
  userDrawerNotActivated: string
  userDrawerMfaAccess: string
  userDrawerAccountLocked: string
  userDrawerPassword: string
  userDrawerPasswordExpiration: string
  userDrawerPwdNeverExpires: string
  userDrawerActivity: string
  userDrawerCreatedAt: string
  usersDrawerClose: string
  usersViewDetails: string
  userDrawerDevices: string
  userDrawerThreats: string
  userDrawerNoDevices: string
  userDrawerNoThreats: string
  userDrawerLoading: string
  userDrawerError: string
  userDrawerActions: string
  actionUnlock: string
  actionUnlockDesc: string
  actionUnlockConfirm: string
  actionExpirePassword: string
  actionExpirePasswordDesc: string
  actionExpirePasswordConfirm: string
  actionSuspend: string
  actionSuspendDesc: string
  actionSuspendConfirm: string
  actionTypedConfirmLabel: string
  actionCancel: string
  actionConfirm: string
  actionSuccess: string
  actionError: string
  activityRecentTitle: string
  activityNew7d: string
  activityNew7dHint: string
  activityNew30d: string
  activitySuspended: string
  activitySuspendedHint: string
  activityHighRisk: string
  activityHighRiskHint: string
  paginationPrev: string
  paginationNext: string
  paginationPageOf: string
  // TopThreeActions (Z2)
  topActionSectionTitle: string
  topActionSectionSubtitle: string
  topActionAllClearTitle: string
  topActionAllClearSubtitle: string
  topActionDetectionsTitle: string
  topActionDetectionsSubtitle: string
  topActionReviewDetections: string
  topActionVulnsTitle: string
  topActionVulnsSubtitle: string
  topActionReviewVulns: string
  topActionMfaTitle: string
  topActionMfaSubtitle: string
  topActionForceMfa: string
  topActionViewUsers: string
  topActionDarkWebTitle: string
  topActionDarkWebSubtitle: string
  topActionDarkWebSubtitleWithSale: string
  topActionInvestigateDarkWeb: string
  topActionLastYear: string
  topActionShadowTitle: string
  topActionShadowSubtitle: string
  topActionReviewApps: string
  topActionSuspendedTitle: string
  topActionSuspendedSubtitle: string
  topActionReviewSuspended: string
  severityCritical: string
  severityHigh: string
  severityMedium: string
  mfaAdoptionShort: string
  spotlightNotLicensedTitle: string
  spotlightNotLicensedBody: string
  spotlightNotLicensedBadge: string
  devicesSummaryTotal: string
  devicesSummaryOnline: string
  devicesSummaryOffline: string
  devicesPlatform: string
  devicesHostname: string
  devicesOS: string
  devicesLastSeen: string
  devicesCSStatus: string
  devicesSensorVersion: string
  devicesOnline: string
  devicesOffline: string
  devicesSearchPlaceholder: string
  devicesNoDevices: string

  // Recommendations
  reviewEachDetection: string
  isolateCompromised: string
  documentInvestigation: string
  prioritizePatches: string
  scheduleUpdates: string
  verifyPatches: string
  contactUsersForMFA: string
  considerMFAPolicy: string
  offerAuthenticatorSupport: string
  revokeAccessSuspended: string
  reviewOffboarding: string
  implementAutoRevocation: string
  evaluateAppsNeeded: string
  blockHighRiskApps: string
  communicateSoftwarePolicy: string
}

export const translations: Record<Language, Translations> = {
  es: {
    // Header
    securityOverview: 'Security Overview',
    updatedNow: 'Actualizado ahora',
    updatedAgo: 'Actualizado hace',
    exportPDF: 'Exportar PDF',
    refresh: 'Actualizar',
    refreshing: 'Actualizando...',

    // Time ranges
    last24h: '24h',
    last7d: '7 días',
    last30d: '30 días',

    // Sidebar sections
    principal: 'PRINCIPAL',
    dashboard: 'Dashboard',
    threats: 'Amenazas',
    users: 'Usuarios',
    devices: 'Dispositivos',
    security: 'SEGURIDAD',
    vulnerabilities: 'Vulnerabilidades',
    mfaAccess: 'MFA & Acceso',
    compliance: 'Compliance',
    reports: 'REPORTES',
    export: 'Exportar',
    history: 'Historial',
    account: 'CUENTA',
    billing: 'Facturación',
    branding: 'Marca',
    billingTitle: 'Mis Facturas',
    billingSubtitle: 'Histórico y estado de cobranza',
    billingLoading: 'Cargando histórico…',
    billingEmpty: 'Todavía no hay periodos facturados. Se registran el día 15 de cada mes.',
    billingLegalName: 'Razón Social',
    billingTaxId: 'RUT/NIF',
    billingCountry: 'País',
    billingPaymentTerms: 'Condiciones',
    billingSummaryPeriods: 'Periodos registrados',
    billingSummaryOutstanding: 'Por cobrar',
    billingSummaryPaid: 'Pagado',
    billingSummaryLastInvoice: 'Última factura',
    billingHistoryTitle: 'Historial mensual',
    billingPeriodSingular: 'periodo',
    billingPeriodPlural: 'periodos',
    billingColPeriod: 'Periodo',
    billingColUsers: 'Usuarios',
    billingColPricePerUser: '$/usuario',
    billingColTotal: 'Total USD',
    billingColStatus: 'Estado',
    billingColInvoice: 'Factura',
    billingColDue: 'Vencimiento',
    billingPaidOn: 'Pagada',
    billingDownloadPdf: 'Descargar PDF',
    billingStatusPending: 'Pendiente',
    billingStatusSentFi: 'En emisión',
    billingStatusInvoiced: 'Facturada',
    billingStatusPaid: 'Pagada',
    billingStatusOverdue: 'Vencida',
    billingStatusVoid: 'Anulada',

    // SaaS metrics
    saasMrr: 'MRR',
    saasArr: 'ARR',
    saasArpu: 'ARPU',
    saasGrowthMom: 'Crecimiento MoM',
    saasNrr: 'NRR (Net Revenue Retention)',
    saasLtv: 'LTV (proxy)',
    saasMonthlyChurn: 'Churn mensual',
    saasForecastTitle: 'Proyección a 3 meses',
    saasForecastSubtitle: 'Extrapolación lineal con los últimos 3 meses completos.',
    saasInsufficientData: 'Datos insuficientes',

    // Score Card
    securityHealthScore: 'Security Health Score',
    basedOn: 'Basado en JumpCloud + CrowdStrike',
    goal: 'Meta',
    goalGradeB: 'Meta: Grado B (80+)',
    pointsPossible: 'pts posibles',
    of100: 'de 100',
    protectionEndpoints: 'Protección Endpoints',
    userSecurity: 'Seguridad Usuarios',
    vulnerabilitiesLabel: 'Vulnerabilidades',
    connectivity: 'Conectividad',

    // Priority Actions
    priorityActions: 'Acciones Prioritarias',
    resolveToImprove: 'Resolver para mejorar tu score',
    activeDetectionsUnresolved: 'detecciones activas sin resolver',
    activeDetectionUnresolved: 'detección activa sin resolver',
    criticalCVEsUnpatched: 'CVEs críticos sin parchear',
    criticalCVEUnpatched: 'CVE crítico sin parchear',
    usersWithoutMFA: 'usuarios sin MFA activo',
    userWithoutMFA: 'usuario sin MFA activo',
    suspendedAccountsWithAccess: 'cuentas suspendidas con acceso',
    suspendedAccountWithAccess: 'cuenta suspendida con acceso',
    unauthorizedAppsDetected: 'apps no autorizadas detectadas',
    unauthorizedAppDetected: 'app no autorizada detectada',
    criticalLabel: 'Crítico',
    highLabel: 'Alto',
    mediumLabel: 'Medio',
    lowLabel: 'Bajo',

    // Metric Cards
    threatsBlocked: 'Amenazas Bloqueadas',
    last7Days: 'Últimos 7 días',
    activeDetections: 'Detecciones Activas',
    requireReview: 'Requieren revisión',
    avgMTTR: 'MTTR Promedio',
    responseTime: 'Tiempo de respuesta',
    devicesLabel: 'Dispositivos',
    withCrowdStrike: '100% con CrowdStrike',
    protectedDevices: 'Dispositivos Protegidos',
    usersLabel: 'Usuarios',
    fromJumpCloud: 'JumpCloud IAM',
    mfaAdoptionLabel: 'Estado MFA',
    totalVulnerabilities: 'Vulnerabilidades',
    fromSpotlight: 'CrowdStrike Spotlight',

    // Threats Table
    usersWithActiveThreats: 'Usuarios con Amenazas Activas',
    correlationJumpCloudCrowdStrike: 'Correlación JumpCloud + CrowdStrike',
    user: 'Usuario',
    device: 'Dispositivo',
    detection: 'Detección',
    severity: 'Severidad',
    action: 'Acción',
    noActiveThreatsAllBlocked: 'Sin amenazas activas. Todas las amenazas fueron bloqueadas.',
    investigate: 'Investigar',
    tactic: 'Tactic',

    // Vulnerabilities
    vulnerabilitiesSpotlight: 'Vulnerabilidades (Spotlight)',
    critical: 'Críticas',
    high: 'Altas',
    medium: 'Medias',
    low: 'Bajas',
    cvesExploitedActively: 'CVEs explotados activamente',
    affectsDevices: 'afecta',
    patchAvailable: 'Parche disponible',
    noPatch: 'Sin parche',
    viewDetails: 'Ver detalles',
    deviceAffected: 'dispositivo afectado',
    devicesAffected: 'dispositivos afectados',

    // MFA Status
    mfaStatus: 'Estado de MFA',
    goalMFA: 'Meta: 100%',
    usersWithMFA: 'Usuarios con MFA',
    totpAuthenticator: 'TOTP (Authenticator)',
    pushNotifications: 'Push Notifications',
    withoutMFAActive: 'Sin MFA (activos)',
    adoption: 'Adopción',

    // Anomalies
    unusualGeoAccess: 'Accesos Geográficos Inusuales',
    loginFromCountry: 'Login desde',
    usualLocation: 'Ubicación habitual',
    impossibleTravel: 'Viaje imposible',
    countriesInHour: 'países en 1 hora',
    blockUser: 'Bloquear usuario',
    revokeSessions: 'Revocar sesiones',

    // Shadow IT / SaaS Management
    unauthorizedApps: 'Aplicaciones No Autorizadas',
    shadowITDetectedBy: 'Shadow IT detectado por Discover',
    application: 'Aplicación',
    devicesCount: 'Dispositivos',
    risk: 'Riesgo',
    block: 'Bloquear',
    remoteAccess: 'Remote Access',
    p2pFileSharing: 'P2P / File Sharing',
    saasApplications: 'Aplicaciones SaaS',
    jumpCloudSaaSManagement: 'JumpCloud AI & SaaS Management',
    newlyDiscovered: 'Nuevas',
    approved: 'Aprobadas',
    unapproved: 'No Aprobadas',
    ignored: 'Ignoradas',
    noSaaSAppsDetected: 'No se detectaron aplicaciones SaaS',
    saaSAppsWillAppear: 'Las aplicaciones aparecerán cuando los usuarios las utilicen',
    discovered: 'Descubierta',
    moreApps: 'aplicaciones más',
    status: 'Estado',

    // Compliance
    policyCompliance: 'Compliance de Políticas',
    jumpCloudPolicies: 'JumpCloud Device Policies',
    diskEncryption: 'Disk Encryption',
    screenLock: 'Screen Lock',
    firewall: 'Firewall',
    osUpdated: 'OS Updated',
    notCompliant: 'sin cumplir',

    // ZTA
    zeroTrustAssessment: 'Zero Trust Assessment',
    crowdstrikeZTA: 'CrowdStrike ZTA Score',
    sensorHealth: 'Sensor Health',
    osSecurity: 'OS Security',
    patchStatus: 'Patch Status',
    browserPlugins: 'Browser Plugins',
    aboveThreshold: 'ABOVE THRESHOLD',
    belowThreshold: 'BELOW THRESHOLD',
    threshold: 'Threshold',

    // Benchmarks
    yourPostureVsIndustry: 'Tu Postura vs. Industria Fintech',
    mfaAdoption: 'MFA Adoption',
    patchCompliance: 'Patch Compliance',
    mttd: 'MTTD',
    endpointCoverage: 'Endpoint Coverage',
    you: 'Tú',
    industry: 'Industria',
    better: 'Mejor',
    needsImprovement: 'Mejorar',

    // ROI
    valueGeneratedByJarix: 'Valor Generado por Jarix',
    estimationBasedOnMetrics: 'Estimación basada en métricas de seguridad',
    estimatedSavings: 'Ahorro Estimado',
    basedOnMTTR: 'basado en MTTR',
    avoidedIncidents: 'Incidentes Evitados',
    blockedThreatsLabel: 'amenazas bloqueadas',
    protectedAssets: 'Activos Protegidos',
    devicesAndUsers: 'dispositivos y usuarios',
    lossesAvoided: 'Pérdidas Evitadas',
    lossesAvoidedDesc: 'amenazas bloqueadas × $15K promedio',
    timeSaved: 'Tiempo Ahorrado',
    timeSavedDesc: 'hrs de respuesta × $150/hr',
    complianceGapsClosed: 'Compliance Gaps Cerrados',
    complianceGapsClosedDesc: 'Evita multas y hallazgos PCI-DSS',

    // Timeline
    securityScoreEvolution: 'Evolución del Security Score',
    historicalTrend: 'Tendencia histórica',
    lastMonths: 'Últimos 6 meses',
    eventNewUsers: 'nuevos usuarios',
    eventEndpointsInstalled: 'endpoints instalados',
    eventMFAEnabled: 'MFA habilitado',
    lastDaysWithEvents: 'Últimos 30 días con eventos relevantes',
    ransomwareBlocked: 'Ransomware bloqueado',
    cvesPatched: 'CVEs parcheados',
    noSecurityEventsRecorded: 'No se registraron eventos de seguridad en este periodo',
    scoreHistoryWillAppear: 'El historial de score aparecerá a medida que se detecten eventos',

    // Modals
    close: 'Cerrar',
    cveDetails: 'Detalle de CVEs Críticos',
    criticalVulnerabilities: 'Vulnerabilidades críticas',
    cveExploitedWarning: 'Estas vulnerabilidades requieren atención inmediata.',
    cveId: 'CVE ID',
    description: 'Descripción',
    affectedDevices: 'Dispositivos Afectados',
    patch: 'Parche',
    available: 'Disponible',
    pending: 'Pendiente',
    recommended: 'Recomendado',
    applyPatch: 'Aplicar Parche',
    viewInSpotlight: 'Ver en Spotlight',
    viewInCrowdStrike: 'Ver en CrowdStrike',
    activeProtection: 'Protección Activa',

    // CVE Modal
    cvesActive: 'CVEs Activos',
    cvesExploitedInWild: 'Estas vulnerabilidades están siendo explotadas activamente en el wild. Prioriza su remediación inmediatamente.',
    detectedVulnerabilities: 'Vulnerabilidades Detectadas',
    applyPatchesImmediately: 'Aplica los parches disponibles inmediatamente en los dispositivos afectados',
    implementMitigation: 'Para CVEs sin parche, implementa medidas de mitigación temporales',
    monitorAffectedDevices: 'Monitorea los dispositivos afectados por actividad sospechosa',

    // Vuln Drill-Down Modal
    vulnDrillTitle: 'Vulnerabilidades',
    vulnDrillSubtitle: 'CVEs que afectan tus dispositivos',
    vulnDrillAffectedDevices: 'Dispositivos Afectados',
    vulnDrillNoCVEs: 'No se encontraron CVEs para esta severidad',
    vulnDrillLoading: 'Cargando vulnerabilidades...',
    vulnDrillViewInCS: 'Ver en CrowdStrike',
    vulnDrillShowMore: 'Mostrar más CVEs',
    vulnDrillCVEs: 'CVEs',

    // Blocked Threats Modal
    blockedThreatsTitle: 'Amenazas Bloqueadas',
    blockedThreatsDescription: 'CrowdStrike ha bloqueado exitosamente {count} amenazas en los últimos 7 días, protegiendo tus dispositivos y datos de forma proactiva.',
    blocked: 'Bloqueadas',
    needAttention: 'Requieren Atención',
    blockRate: 'Tasa de Bloqueo',
    threatsByCategory: 'Desglose por Tipo de Amenaza',
    malware: 'Malware',
    malwareDesc: 'Archivos maliciosos bloqueados antes de ejecutarse',
    ransomware: 'Ransomware',
    ransomwareDesc: 'Intentos de cifrado de archivos prevenidos',
    phishing: 'Phishing',
    phishingDesc: 'Enlaces y archivos de phishing detectados',
    exploits: 'Exploits',
    exploitsDesc: 'Intentos de explotación de vulnerabilidades',
    pups: 'PUPs',
    pupsDesc: 'Programas potencialmente no deseados',
    whatDoesThisMean: '¿Qué significa esto?',
    realTimeProtection: 'Tu organización está protegida por detección en tiempo real',
    threatsNeutralized: 'Las amenazas fueron neutralizadas automáticamente sin afectar operaciones',
    mlPreventedZeroDay: 'El machine learning de CrowdStrike previno ataques zero-day',
    viewAllThreats: 'Ver Todas las Amenazas',
    downloadReport: 'Descargar Reporte',

    // Action Modal
    impactedItems: 'Elementos afectados',
    recommendations: 'Recomendaciones',
    goToSection: 'Ir a la sección',
    viewRelatedSection: 'Ver sección relacionada',

    // Actions descriptions
    detectionsDescription: 'Hay detecciones de seguridad activas que requieren investigación inmediata. Estas pueden indicar actividad maliciosa o intentos de compromiso.',
    cvesDescription: 'Existen vulnerabilidades críticas conocidas que podrían ser explotadas por atacantes. Aplicar parches es urgente.',
    mfaDescription: 'Usuarios sin autenticación multifactor son vulnerables a ataques de phishing y robo de credenciales.',
    suspendedDescription: 'Cuentas suspendidas que aún tienen acceso a recursos. Esto representa un riesgo de acceso no autorizado.',
    shadowItDescription: 'Se detectaron aplicaciones no autorizadas que podrían representar riesgos de seguridad o compliance.',

    // Cyber Risk Report
    cyberRiskTitle: 'Informe de Ciber-Riesgo',
    cyberRiskRiskScore: 'Risk Score',
    cyberRiskGrade: 'Grado',
    cyberRiskLastAssessment: 'Última evaluación',
    cyberRiskSecurityProfile: 'Perfil de Seguridad',
    cyberRiskSeverity: 'Severidad',
    cyberRiskDownloadReport: 'Descargar Reporte PDF',
    cyberRiskViewInSocRadar: 'Ver en SocRadar',
    cyberRiskNoData: 'No hay informe de riesgo disponible para este tenant',
    cyberRiskSyncPending: 'Datos detallados disponibles después de sincronización',
    cyberRiskCategory: 'Categoría',
    cyberRiskImpact: 'Impacto',

    // SocRadar PDF Report
    socradarReportTitle: 'Evaluación de Ciber Inteligencia',
    socradarReportScores: 'Scores de Seguridad',
    socradarReportCVEs: 'Vulnerabilidades Detectadas',
    socradarReportDarkWeb: 'Inteligencia Dark Web',
    socradarReportEmail: 'Seguridad de Email',
    socradarReportRansomware: 'Evaluacion de Ransomware',
    socradarReportInfra: 'Infraestructura',
    socradarReportNoData: 'No hay reporte disponible para este dominio',
    socradarReportSafe: 'Sin CVEs de ransomware',
    socradarReportDownload: 'Descargar PDF',

    // Section Headers - Alerts, Users, Devices
    securityAlertsTitle: 'Alertas de Seguridad',
    jumpcloudUsersTitle: 'Usuarios JumpCloud',
    devicesTitle: 'Dispositivos',
    alertsSource: 'Fuente',
    alertsDate: 'Fecha',
    alertsDescription: 'Descripcion',
    alertsSeverity: 'Severidad',
    alertsStatus: 'Estado',
    alertsNoAlerts: 'No hay alertas de seguridad en el periodo seleccionado',
    alertsAll: 'Todas',
    usersSummaryTotal: 'Total Usuarios',
    usersSummaryActive: 'Activos',
    usersSummarySuspended: 'Suspendidos',
    usersSummaryNoMFA: 'Sin MFA',
    usersName: 'Nombre',
    usersEmail: 'Email',
    usersStatus: 'Estado',
    usersMFA: 'MFA',
    usersLastLogin: 'Ultimo Login',
    usersPasswordStatus: 'Estado Contrasena',
    usersActive: 'Activo',
    usersSuspended: 'Suspendido',
    usersYes: 'Si',
    usersNo: 'No',
    usersNever: 'Nunca',
    usersExpired: 'Expirada',
    usersValid: 'Vigente',
    usersSearchPlaceholder: 'Buscar por nombre o email...',
    usersMFAType: 'Tipo MFA',
    usersMFATotp: 'TOTP',
    usersMFAWebauthn: 'WebAuthn',
    usersMFAPush: 'Push',
    usersMFASms: 'SMS',
    usersMFANone: 'Ninguno',
    usersFilterAll: 'Todos',
    usersFilterNoMFA: 'Sin MFA',
    usersFilterPasswordExpiring: 'Expira en 14d',
    usersFilterLocked: 'Bloqueados',
    usersFilterNewUsers: 'Nuevos 7d',
    usersFilterInactive: 'Inactivos 90d',
    usersFilterActive: 'Activos',
    usersFilterSuspended: 'Suspendidos',
    usersFilterLabel: 'Filtro',
    usersExportCSV: 'Exportar CSV',
    usersNoResults: 'No hay usuarios que coincidan con el filtro',
    usersShowingCount: 'Mostrando {visible} de {total}',
    usersRisk: 'Riesgo',
    usersFilterHighRisk: 'Alto Riesgo',
    userRiskLow: 'Bajo',
    userRiskMedium: 'Medio',
    userRiskHigh: 'Alto',
    userDrawerRiskTitle: 'Puntuación de Riesgo',
    userDrawerNoRiskFactors: 'Sin factores de riesgo detectados',
    userDrawerIdentity: 'Identidad',
    userDrawerUsername: 'Usuario',
    userDrawerUserId: 'ID',
    userDrawerNotActivated: 'No activado',
    userDrawerMfaAccess: 'MFA y Acceso',
    userDrawerAccountLocked: 'Cuenta Bloqueada',
    userDrawerPassword: 'Contraseña',
    userDrawerPasswordExpiration: 'Expiración',
    userDrawerPwdNeverExpires: 'Nunca expira',
    userDrawerActivity: 'Actividad',
    userDrawerCreatedAt: 'Creado',
    usersDrawerClose: 'Cerrar panel',
    usersViewDetails: 'Ver detalles',
    userDrawerDevices: 'Dispositivos Asignados',
    userDrawerThreats: 'Amenazas Recientes',
    userDrawerNoDevices: 'Sin dispositivos correlacionados',
    userDrawerNoThreats: 'Sin amenazas recientes',
    userDrawerLoading: 'Cargando...',
    userDrawerError: 'Error al cargar correlación',
    userDrawerActions: 'Acciones',
    actionUnlock: 'Desbloquear cuenta',
    actionUnlockDesc: 'Permitir al usuario iniciar sesión',
    actionUnlockConfirm: '¿Desbloquear la cuenta de {email}? Podrá iniciar sesión de nuevo.',
    actionExpirePassword: 'Forzar cambio de contraseña',
    actionExpirePasswordDesc: 'Obliga al usuario a cambiarla en el próximo inicio',
    actionExpirePasswordConfirm: '¿Forzar a {email} a cambiar contraseña en el próximo login?',
    actionSuspend: 'Suspender usuario',
    actionSuspendDesc: 'Revoca acceso inmediato (reversible)',
    actionSuspendConfirm: '⚠️ SUSPENDER a {email} revoca acceso inmediatamente a todas sus aplicaciones. Esta acción es reversible pero interrumpe su trabajo.',
    actionTypedConfirmLabel: 'Para confirmar, escribe el email del usuario: {email}',
    actionCancel: 'Cancelar',
    actionConfirm: 'Confirmar',
    actionSuccess: 'Acción ejecutada correctamente',
    actionError: 'Error al ejecutar la acción',
    activityRecentTitle: 'Actividad reciente',
    activityNew7d: 'Nuevos (7d)',
    activityNew7dHint: 'Filtrar usuarios creados en los últimos 7 días',
    activityNew30d: 'Nuevos (30d)',
    activitySuspended: 'Suspendidos',
    activitySuspendedHint: 'Filtrar usuarios suspendidos',
    activityHighRisk: 'Alto Riesgo',
    activityHighRiskHint: 'Filtrar usuarios con puntuación de riesgo alta',
    paginationPrev: 'Anterior',
    paginationNext: 'Siguiente',
    paginationPageOf: 'Página {page} de {total}',
    // TopThreeActions (Z2)
    topActionSectionTitle: 'Prioridades de hoy',
    topActionSectionSubtitle: 'Ordenadas por severidad',
    topActionAllClearTitle: 'Sin alertas prioritarias',
    topActionAllClearSubtitle: 'Tu postura está en orden. Jarix sigue monitoreando.',
    topActionDetectionsTitle: '{count} detecciones EDR sin resolver',
    topActionDetectionsSubtitle: 'Amenazas activas detectadas por CrowdStrike que requieren revisión.',
    topActionReviewDetections: 'Revisar detecciones',
    topActionVulnsTitle: '{critical} críticas · {high} altas',
    topActionVulnsSubtitle: 'Vulnerabilidades con CVSS alto detectadas por Spotlight.',
    topActionReviewVulns: 'Ver vulnerabilidades',
    topActionMfaTitle: '{count} usuarios sin MFA',
    topActionMfaSubtitle: 'Adopción actual {rate}%. Cuentas sin segundo factor.',
    topActionForceMfa: 'Forzar MFA',
    topActionViewUsers: 'Ver usuarios',
    topActionDarkWebTitle: '{count} credenciales expuestas',
    topActionDarkWebSubtitle: '{leaks} credenciales filtradas en el último año.',
    topActionDarkWebSubtitleWithSale: '{leaks} filtradas + {sale} en venta en Russian Market.',
    topActionInvestigateDarkWeb: 'Investigar',
    topActionLastYear: 'Último año',
    topActionShadowTitle: '{count} apps SaaS no aprobadas',
    topActionShadowSubtitle: 'Aplicaciones detectadas en uso sin revisión de seguridad.',
    topActionReviewApps: 'Revisar apps',
    topActionSuspendedTitle: '{count} usuarios suspendidos con acceso residual',
    topActionSuspendedSubtitle: 'Cuentas desactivadas que aún figuran en la organización. Elimínalas para cumplir con PCI DSS 8.2.',
    topActionReviewSuspended: 'Ver usuarios',
    severityCritical: 'Crítico',
    severityHigh: 'Alto',
    severityMedium: 'Medio',
    mfaAdoptionShort: 'adopción',
    spotlightNotLicensedTitle: 'Spotlight no incluido en el plan actual',
    spotlightNotLicensedBody: 'Vulnerability Management (CrowdStrike Spotlight) es un módulo adicional. Contáctanos para habilitarlo y detectar CVEs en tus dispositivos.',
    spotlightNotLicensedBadge: 'No licenciado',
    devicesSummaryTotal: 'Total Dispositivos',
    devicesSummaryOnline: 'En Linea',
    devicesSummaryOffline: 'Desconectados',
    devicesPlatform: 'Plataforma',
    devicesHostname: 'Hostname',
    devicesOS: 'Sistema Operativo',
    devicesLastSeen: 'Ultima Conexion',
    devicesCSStatus: 'Estado CrowdStrike',
    devicesSensorVersion: 'Version Sensor',
    devicesOnline: 'En Linea',
    devicesOffline: 'Desconectado',
    devicesSearchPlaceholder: 'Buscar por hostname...',
    devicesNoDevices: 'No hay dispositivos registrados',

    // Recommendations
    reviewEachDetection: 'Revisar cada detección en la consola de CrowdStrike',
    isolateCompromised: 'Aislar dispositivos comprometidos si es necesario',
    documentInvestigation: 'Documentar la investigación y acciones tomadas',
    prioritizePatches: 'Priorizar parches según criticidad y exposición',
    scheduleUpdates: 'Programar ventanas de mantenimiento para actualizaciones',
    verifyPatches: 'Verificar que los parches se aplicaron correctamente',
    contactUsersForMFA: 'Contactar a los usuarios para habilitar MFA',
    considerMFAPolicy: 'Considerar política de MFA obligatorio',
    offerAuthenticatorSupport: 'Ofrecer soporte para configuración de authenticator',
    revokeAccessSuspended: 'Revocar accesos de cuentas suspendidas',
    reviewOffboarding: 'Revisar política de offboarding',
    implementAutoRevocation: 'Implementar automatización de revocación',
    evaluateAppsNeeded: 'Evaluar si las apps son necesarias para el negocio',
    blockHighRiskApps: 'Bloquear apps de alto riesgo',
    communicateSoftwarePolicy: 'Comunicar política de software autorizado',
  },

  en: {
    // Header
    securityOverview: 'Security Overview',
    updatedNow: 'Updated now',
    updatedAgo: 'Updated',
    exportPDF: 'Export PDF',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',

    // Time ranges
    last24h: '24h',
    last7d: '7 days',
    last30d: '30 days',

    // Sidebar sections
    principal: 'MAIN',
    dashboard: 'Dashboard',
    threats: 'Threats',
    users: 'Users',
    devices: 'Devices',
    security: 'SECURITY',
    vulnerabilities: 'Vulnerabilities',
    mfaAccess: 'MFA & Access',
    compliance: 'Compliance',
    reports: 'REPORTS',
    export: 'Export',
    history: 'History',
    account: 'ACCOUNT',
    billing: 'Billing',
    branding: 'Branding',
    billingTitle: 'My Invoices',
    billingSubtitle: 'History and payment status',
    billingLoading: 'Loading history…',
    billingEmpty: 'No billing periods yet. They are captured on the 15th of each month.',
    billingLegalName: 'Legal Name',
    billingTaxId: 'Tax ID',
    billingCountry: 'Country',
    billingPaymentTerms: 'Payment Terms',
    billingSummaryPeriods: 'Periods tracked',
    billingSummaryOutstanding: 'Outstanding',
    billingSummaryPaid: 'Paid',
    billingSummaryLastInvoice: 'Last invoice',
    billingHistoryTitle: 'Monthly history',
    billingPeriodSingular: 'period',
    billingPeriodPlural: 'periods',
    billingColPeriod: 'Period',
    billingColUsers: 'Users',
    billingColPricePerUser: '$/user',
    billingColTotal: 'Total USD',
    billingColStatus: 'Status',
    billingColInvoice: 'Invoice',
    billingColDue: 'Due',
    billingPaidOn: 'Paid',
    billingDownloadPdf: 'Download PDF',
    billingStatusPending: 'Pending',
    billingStatusSentFi: 'In process',
    billingStatusInvoiced: 'Invoiced',
    billingStatusPaid: 'Paid',
    billingStatusOverdue: 'Overdue',
    billingStatusVoid: 'Void',

    // SaaS metrics
    saasMrr: 'MRR',
    saasArr: 'ARR',
    saasArpu: 'ARPU',
    saasGrowthMom: 'MoM Growth',
    saasNrr: 'NRR (Net Revenue Retention)',
    saasLtv: 'LTV (proxy)',
    saasMonthlyChurn: 'Monthly churn',
    saasForecastTitle: '3-month forecast',
    saasForecastSubtitle: 'Linear extrapolation based on the last 3 complete months.',
    saasInsufficientData: 'Insufficient data',

    // Score Card
    securityHealthScore: 'Security Health Score',
    basedOn: 'Based on JumpCloud + CrowdStrike',
    goal: 'Goal',
    goalGradeB: 'Goal: Grade B (80+)',
    pointsPossible: 'pts possible',
    of100: 'of 100',
    protectionEndpoints: 'Endpoint Protection',
    userSecurity: 'User Security',
    vulnerabilitiesLabel: 'Vulnerabilities',
    connectivity: 'Connectivity',

    // Priority Actions
    priorityActions: 'Priority Actions',
    resolveToImprove: 'Resolve to improve your score',
    activeDetectionsUnresolved: 'active detections unresolved',
    activeDetectionUnresolved: 'active detection unresolved',
    criticalCVEsUnpatched: 'critical CVEs unpatched',
    criticalCVEUnpatched: 'critical CVE unpatched',
    usersWithoutMFA: 'users without active MFA',
    userWithoutMFA: 'user without active MFA',
    suspendedAccountsWithAccess: 'suspended accounts with access',
    suspendedAccountWithAccess: 'suspended account with access',
    unauthorizedAppsDetected: 'unauthorized apps detected',
    unauthorizedAppDetected: 'unauthorized app detected',
    criticalLabel: 'Critical',
    highLabel: 'High',
    mediumLabel: 'Medium',
    lowLabel: 'Low',

    // Metric Cards
    threatsBlocked: 'Threats Blocked',
    last7Days: 'Last 7 days',
    activeDetections: 'Active Detections',
    requireReview: 'Require review',
    avgMTTR: 'Avg MTTR',
    responseTime: 'Response time',
    devicesLabel: 'Devices',
    withCrowdStrike: '100% with CrowdStrike',
    protectedDevices: 'Protected Devices',
    usersLabel: 'Users',
    fromJumpCloud: 'JumpCloud IAM',
    mfaAdoptionLabel: 'MFA Status',
    totalVulnerabilities: 'Vulnerabilities',
    fromSpotlight: 'CrowdStrike Spotlight',

    // Threats Table
    usersWithActiveThreats: 'Users with Active Threats',
    correlationJumpCloudCrowdStrike: 'JumpCloud + CrowdStrike Correlation',
    user: 'User',
    device: 'Device',
    detection: 'Detection',
    severity: 'Severity',
    action: 'Action',
    noActiveThreatsAllBlocked: 'No active threats. All threats were blocked.',
    investigate: 'Investigate',
    tactic: 'Tactic',

    // Vulnerabilities
    vulnerabilitiesSpotlight: 'Vulnerabilities (Spotlight)',
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    cvesExploitedActively: 'CVEs actively exploited',
    affectsDevices: 'affects',
    patchAvailable: 'Patch available',
    noPatch: 'No patch',
    viewDetails: 'View details',
    deviceAffected: 'device affected',
    devicesAffected: 'devices affected',

    // MFA Status
    mfaStatus: 'MFA Status',
    goalMFA: 'Goal: 100%',
    usersWithMFA: 'Users with MFA',
    totpAuthenticator: 'TOTP (Authenticator)',
    pushNotifications: 'Push Notifications',
    withoutMFAActive: 'Without MFA (active)',
    adoption: 'Adoption',

    // Anomalies
    unusualGeoAccess: 'Unusual Geographic Access',
    loginFromCountry: 'Login from',
    usualLocation: 'Usual location',
    impossibleTravel: 'Impossible travel',
    countriesInHour: 'countries in 1 hour',
    blockUser: 'Block user',
    revokeSessions: 'Revoke sessions',

    // Shadow IT / SaaS Management
    unauthorizedApps: 'Unauthorized Applications',
    shadowITDetectedBy: 'Shadow IT detected by Discover',
    application: 'Application',
    devicesCount: 'Devices',
    risk: 'Risk',
    block: 'Block',
    remoteAccess: 'Remote Access',
    p2pFileSharing: 'P2P / File Sharing',
    saasApplications: 'SaaS Applications',
    jumpCloudSaaSManagement: 'JumpCloud AI & SaaS Management',
    newlyDiscovered: 'New',
    approved: 'Approved',
    unapproved: 'Unapproved',
    ignored: 'Ignored',
    noSaaSAppsDetected: 'No SaaS applications detected yet',
    saaSAppsWillAppear: 'Applications will appear as users access them',
    discovered: 'Discovered',
    moreApps: 'more applications',
    status: 'Status',

    // Compliance
    policyCompliance: 'Policy Compliance',
    jumpCloudPolicies: 'JumpCloud Device Policies',
    diskEncryption: 'Disk Encryption',
    screenLock: 'Screen Lock',
    firewall: 'Firewall',
    osUpdated: 'OS Updated',
    notCompliant: 'not compliant',

    // ZTA
    zeroTrustAssessment: 'Zero Trust Assessment',
    crowdstrikeZTA: 'CrowdStrike ZTA Score',
    sensorHealth: 'Sensor Health',
    osSecurity: 'OS Security',
    patchStatus: 'Patch Status',
    browserPlugins: 'Browser Plugins',
    aboveThreshold: 'ABOVE THRESHOLD',
    belowThreshold: 'BELOW THRESHOLD',
    threshold: 'Threshold',

    // Benchmarks
    yourPostureVsIndustry: 'Your Posture vs. Fintech Industry',
    mfaAdoption: 'MFA Adoption',
    patchCompliance: 'Patch Compliance',
    mttd: 'MTTD',
    endpointCoverage: 'Endpoint Coverage',
    you: 'You',
    industry: 'Industry',
    better: 'Better',
    needsImprovement: 'Improve',

    // ROI
    valueGeneratedByJarix: 'Value Generated by Jarix',
    estimationBasedOnMetrics: 'Estimation based on security metrics',
    estimatedSavings: 'Estimated Savings',
    basedOnMTTR: 'based on MTTR',
    avoidedIncidents: 'Avoided Incidents',
    blockedThreatsLabel: 'blocked threats',
    protectedAssets: 'Protected Assets',
    devicesAndUsers: 'devices and users',
    lossesAvoided: 'Losses Avoided',
    lossesAvoidedDesc: 'blocked threats × $15K average',
    timeSaved: 'Time Saved',
    timeSavedDesc: 'hrs of response × $150/hr',
    complianceGapsClosed: 'Compliance Gaps Closed',
    complianceGapsClosedDesc: 'Avoids fines and PCI-DSS findings',

    // Timeline
    securityScoreEvolution: 'Security Score Evolution',
    historicalTrend: 'Historical trend',
    lastMonths: 'Last 6 months',
    eventNewUsers: 'new users',
    eventEndpointsInstalled: 'endpoints installed',
    eventMFAEnabled: 'MFA enabled',
    lastDaysWithEvents: 'Last 30 days with relevant events',
    ransomwareBlocked: 'Ransomware blocked',
    cvesPatched: 'CVEs patched',
    noSecurityEventsRecorded: 'No security events recorded in this period',
    scoreHistoryWillAppear: 'Score history will appear as events are detected',

    // Modals
    close: 'Close',
    cveDetails: 'Critical CVE Details',
    criticalVulnerabilities: 'Critical vulnerabilities',
    cveExploitedWarning: 'These vulnerabilities require immediate attention.',
    cveId: 'CVE ID',
    description: 'Description',
    affectedDevices: 'Affected Devices',
    patch: 'Patch',
    available: 'Available',
    pending: 'Pending',
    recommended: 'Recommended',
    applyPatch: 'Apply Patch',
    viewInSpotlight: 'View in Spotlight',
    viewInCrowdStrike: 'View in CrowdStrike',
    activeProtection: 'Active Protection',

    // CVE Modal
    cvesActive: 'Active CVEs',
    cvesExploitedInWild: 'These vulnerabilities are being actively exploited in the wild. Prioritize their remediation immediately.',
    detectedVulnerabilities: 'Detected Vulnerabilities',
    applyPatchesImmediately: 'Apply available patches immediately on affected devices',
    implementMitigation: 'For CVEs without patches, implement temporary mitigation measures',
    monitorAffectedDevices: 'Monitor affected devices for suspicious activity',

    // Vuln Drill-Down Modal
    vulnDrillTitle: 'Vulnerabilities',
    vulnDrillSubtitle: 'CVEs affecting your devices',
    vulnDrillAffectedDevices: 'Affected Devices',
    vulnDrillNoCVEs: 'No CVEs found for this severity',
    vulnDrillLoading: 'Loading vulnerabilities...',
    vulnDrillViewInCS: 'View in CrowdStrike',
    vulnDrillShowMore: 'Show more CVEs',
    vulnDrillCVEs: 'CVEs',

    // Blocked Threats Modal
    blockedThreatsTitle: 'Blocked Threats',
    blockedThreatsDescription: 'CrowdStrike has successfully blocked {count} threats in the last 7 days, proactively protecting your devices and data.',
    blocked: 'Blocked',
    needAttention: 'Need Attention',
    blockRate: 'Block Rate',
    threatsByCategory: 'Breakdown by Threat Type',
    malware: 'Malware',
    malwareDesc: 'Malicious files blocked before execution',
    ransomware: 'Ransomware',
    ransomwareDesc: 'File encryption attempts prevented',
    phishing: 'Phishing',
    phishingDesc: 'Phishing links and files detected',
    exploits: 'Exploits',
    exploitsDesc: 'Vulnerability exploitation attempts',
    pups: 'PUPs',
    pupsDesc: 'Potentially unwanted programs',
    whatDoesThisMean: 'What does this mean?',
    realTimeProtection: 'Your organization is protected by real-time detection',
    threatsNeutralized: 'Threats were automatically neutralized without affecting operations',
    mlPreventedZeroDay: 'CrowdStrike machine learning prevented zero-day attacks',
    viewAllThreats: 'View All Threats',
    downloadReport: 'Download Report',

    // Action Modal
    impactedItems: 'Impacted Items',
    recommendations: 'Recommendations',
    goToSection: 'Go to section',
    viewRelatedSection: 'View related section',

    // Actions descriptions
    detectionsDescription: 'There are active security detections that require immediate investigation. These may indicate malicious activity or compromise attempts.',
    cvesDescription: 'There are known critical vulnerabilities that could be exploited by attackers. Patching is urgent.',
    mfaDescription: 'Users without multi-factor authentication are vulnerable to phishing attacks and credential theft.',
    suspendedDescription: 'Suspended accounts that still have access to resources. This represents an unauthorized access risk.',
    shadowItDescription: 'Unauthorized applications were detected that could pose security or compliance risks.',

    // Cyber Risk Report
    cyberRiskTitle: 'Cyber Risk Report',
    cyberRiskRiskScore: 'Risk Score',
    cyberRiskGrade: 'Grade',
    cyberRiskLastAssessment: 'Last assessment',
    cyberRiskSecurityProfile: 'Security Profile',
    cyberRiskSeverity: 'Severity',
    cyberRiskDownloadReport: 'Download PDF Report',
    cyberRiskViewInSocRadar: 'View in SocRadar',
    cyberRiskNoData: 'No cyber risk report available for this tenant',
    cyberRiskSyncPending: 'Detailed scores available after sync',
    cyberRiskCategory: 'Category',
    cyberRiskImpact: 'Impact',

    // SocRadar PDF Report
    socradarReportTitle: 'Cyber Intelligence Assessment',
    socradarReportScores: 'Security Scores',
    socradarReportCVEs: 'Detected Vulnerabilities',
    socradarReportDarkWeb: 'Dark Web Intelligence',
    socradarReportEmail: 'Email Security',
    socradarReportRansomware: 'Ransomware Assessment',
    socradarReportInfra: 'Infrastructure',
    socradarReportNoData: 'No report available for this domain',
    socradarReportSafe: 'No ransomware CVEs found',
    socradarReportDownload: 'Download PDF',

    // Section Headers - Alerts, Users, Devices
    securityAlertsTitle: 'Security Alerts',
    jumpcloudUsersTitle: 'JumpCloud Users',
    devicesTitle: 'Devices',
    alertsSource: 'Source',
    alertsDate: 'Date',
    alertsDescription: 'Description',
    alertsSeverity: 'Severity',
    alertsStatus: 'Status',
    alertsNoAlerts: 'No security alerts in the selected period',
    alertsAll: 'All',
    usersSummaryTotal: 'Total Users',
    usersSummaryActive: 'Active',
    usersSummarySuspended: 'Suspended',
    usersSummaryNoMFA: 'Without MFA',
    usersName: 'Name',
    usersEmail: 'Email',
    usersStatus: 'Status',
    usersMFA: 'MFA',
    usersLastLogin: 'Last Login',
    usersPasswordStatus: 'Password Status',
    usersActive: 'Active',
    usersSuspended: 'Suspended',
    usersYes: 'Yes',
    usersNo: 'No',
    usersNever: 'Never',
    usersExpired: 'Expired',
    usersValid: 'Valid',
    usersSearchPlaceholder: 'Search by name or email...',
    usersMFAType: 'MFA Type',
    usersMFATotp: 'TOTP',
    usersMFAWebauthn: 'WebAuthn',
    usersMFAPush: 'Push',
    usersMFASms: 'SMS',
    usersMFANone: 'None',
    usersFilterAll: 'All',
    usersFilterNoMFA: 'Without MFA',
    usersFilterPasswordExpiring: 'Expires in 14d',
    usersFilterLocked: 'Locked',
    usersFilterNewUsers: 'New 7d',
    usersFilterInactive: 'Inactive 90d',
    usersFilterActive: 'Active',
    usersFilterSuspended: 'Suspended',
    usersFilterLabel: 'Filter',
    usersExportCSV: 'Export CSV',
    usersNoResults: 'No users match the current filter',
    usersShowingCount: 'Showing {visible} of {total}',
    usersRisk: 'Risk',
    usersFilterHighRisk: 'High Risk',
    userRiskLow: 'Low',
    userRiskMedium: 'Medium',
    userRiskHigh: 'High',
    userDrawerRiskTitle: 'Risk Score',
    userDrawerNoRiskFactors: 'No risk factors detected',
    userDrawerIdentity: 'Identity',
    userDrawerUsername: 'Username',
    userDrawerUserId: 'ID',
    userDrawerNotActivated: 'Not activated',
    userDrawerMfaAccess: 'MFA & Access',
    userDrawerAccountLocked: 'Account Locked',
    userDrawerPassword: 'Password',
    userDrawerPasswordExpiration: 'Expiration',
    userDrawerPwdNeverExpires: 'Never expires',
    userDrawerActivity: 'Activity',
    userDrawerCreatedAt: 'Created',
    usersDrawerClose: 'Close panel',
    usersViewDetails: 'View details',
    userDrawerDevices: 'Assigned Devices',
    userDrawerThreats: 'Recent Threats',
    userDrawerNoDevices: 'No correlated devices',
    userDrawerNoThreats: 'No recent threats',
    userDrawerLoading: 'Loading...',
    userDrawerError: 'Error loading correlation',
    userDrawerActions: 'Actions',
    actionUnlock: 'Unlock account',
    actionUnlockDesc: 'Allow the user to log in again',
    actionUnlockConfirm: 'Unlock {email}? They will be able to log in again.',
    actionExpirePassword: 'Force password reset',
    actionExpirePasswordDesc: 'Require password change on next login',
    actionExpirePasswordConfirm: 'Force {email} to reset their password at next login?',
    actionSuspend: 'Suspend user',
    actionSuspendDesc: 'Revoke access immediately (reversible)',
    actionSuspendConfirm: '⚠️ SUSPENDING {email} immediately revokes access to all applications. This is reversible but interrupts their work.',
    actionTypedConfirmLabel: 'To confirm, type the user email: {email}',
    actionCancel: 'Cancel',
    actionConfirm: 'Confirm',
    actionSuccess: 'Action executed successfully',
    actionError: 'Error executing action',
    activityRecentTitle: 'Recent activity',
    activityNew7d: 'New (7d)',
    activityNew7dHint: 'Filter users created in the last 7 days',
    activityNew30d: 'New (30d)',
    activitySuspended: 'Suspended',
    activitySuspendedHint: 'Filter suspended users',
    activityHighRisk: 'High Risk',
    activityHighRiskHint: 'Filter users with high risk score',
    paginationPrev: 'Previous',
    paginationNext: 'Next',
    paginationPageOf: 'Page {page} of {total}',
    // TopThreeActions (Z2)
    topActionSectionTitle: "Today's priorities",
    topActionSectionSubtitle: 'Ranked by severity',
    topActionAllClearTitle: 'No priority alerts',
    topActionAllClearSubtitle: 'Your posture is clean. Jarix keeps watching.',
    topActionDetectionsTitle: '{count} unresolved EDR detections',
    topActionDetectionsSubtitle: 'Active threats detected by CrowdStrike that need review.',
    topActionReviewDetections: 'Review detections',
    topActionVulnsTitle: '{critical} critical · {high} high',
    topActionVulnsSubtitle: 'High-CVSS vulnerabilities detected by Spotlight.',
    topActionReviewVulns: 'View vulnerabilities',
    topActionMfaTitle: '{count} users without MFA',
    topActionMfaSubtitle: 'Adoption currently {rate}%. Accounts lacking 2FA.',
    topActionForceMfa: 'Force MFA',
    topActionViewUsers: 'View users',
    topActionDarkWebTitle: '{count} exposed credentials',
    topActionDarkWebSubtitle: '{leaks} leaked credentials in the last year.',
    topActionDarkWebSubtitleWithSale: '{leaks} leaked + {sale} on sale on Russian Market.',
    topActionInvestigateDarkWeb: 'Investigate',
    topActionLastYear: 'Last year',
    topActionShadowTitle: '{count} unapproved SaaS apps',
    topActionShadowSubtitle: 'Applications in use without security review.',
    topActionReviewApps: 'Review apps',
    topActionSuspendedTitle: '{count} suspended users with residual access',
    topActionSuspendedSubtitle: 'Disabled accounts still present in the directory. Remove them to meet PCI DSS 8.2.',
    topActionReviewSuspended: 'View users',
    severityCritical: 'Critical',
    severityHigh: 'High',
    severityMedium: 'Medium',
    mfaAdoptionShort: 'adoption',
    spotlightNotLicensedTitle: 'Spotlight not included in current plan',
    spotlightNotLicensedBody: 'Vulnerability Management (CrowdStrike Spotlight) is an add-on module. Contact us to enable it and detect CVEs on your devices.',
    spotlightNotLicensedBadge: 'Not licensed',
    devicesSummaryTotal: 'Total Devices',
    devicesSummaryOnline: 'Online',
    devicesSummaryOffline: 'Offline',
    devicesPlatform: 'Platform',
    devicesHostname: 'Hostname',
    devicesOS: 'Operating System',
    devicesLastSeen: 'Last Seen',
    devicesCSStatus: 'CrowdStrike Status',
    devicesSensorVersion: 'Sensor Version',
    devicesOnline: 'Online',
    devicesOffline: 'Offline',
    devicesSearchPlaceholder: 'Search by hostname...',
    devicesNoDevices: 'No devices registered',

    // Recommendations
    reviewEachDetection: 'Review each detection in the CrowdStrike console',
    isolateCompromised: 'Isolate compromised devices if necessary',
    documentInvestigation: 'Document the investigation and actions taken',
    prioritizePatches: 'Prioritize patches based on criticality and exposure',
    scheduleUpdates: 'Schedule maintenance windows for updates',
    verifyPatches: 'Verify that patches were applied correctly',
    contactUsersForMFA: 'Contact users to enable MFA',
    considerMFAPolicy: 'Consider mandatory MFA policy',
    offerAuthenticatorSupport: 'Offer support for authenticator setup',
    revokeAccessSuspended: 'Revoke access from suspended accounts',
    reviewOffboarding: 'Review offboarding policy',
    implementAutoRevocation: 'Implement automatic revocation',
    evaluateAppsNeeded: 'Evaluate if apps are necessary for business',
    blockHighRiskApps: 'Block high-risk apps',
    communicateSoftwarePolicy: 'Communicate authorized software policy',
  },
}

export function getTranslations(lang: Language): Translations {
  return translations[lang]
}
